import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from '../../ui/calendar';
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { getClassesByTeacherAndDateTimeBetweenDays } from '../../../provider/profesor/ListClasess/getClassesByTeacherAndDateTimeBetweenDays';

const DateRangePicker = ({ startDate, setStartDate, endDate, setEndDate}) => {

  const [isOpen, setIsOpen] = useState(false);
  const calendarRef = useRef(null);
  const diasHabilesDespuesDeCierre=10;
  // Obtener fechas límite basadas en la regla de los 10 días
  const now = new Date();
  const currentDay = now.getDate();
  
  let fromDate, toDate;
  
  if (currentDay <= diasHabilesDespuesDeCierre) {
    // Primeros 10 días: permitir mes anterior y actual
    fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    toDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  } else {
    // Después del día 10: solo mes actual
    fromDate = new Date(now.getFullYear(), now.getMonth(), 1);
    toDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  }

  const handleSelect = (date) => {
    if (!startDate || (startDate && endDate)) {
      setStartDate(date);
      setEndDate(null);
    } else {
      if (date < startDate) {
        setEndDate(startDate);
        setStartDate(date);
      } else {
        setEndDate(date);
        setIsOpen(false); // Cerrar calendario cuando se completa el rango
      }
    }
  };

  // Cerrar el calendario cuando se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const disableDate = (date) => {
    // Deshabilitar fechas fuera del rango permitido
    return date < fromDate || date > toDate;
  };

  const isDateInRange = (date) => {
    if (startDate && endDate) {
      return date >= startDate && date <= endDate;
    }
    return false;
  };
  const getMonthsText = () => {
    if (currentDay <= diasHabilesDespuesDeCierre) {
      const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1).toLocaleString('es', { month: 'long' });
      const currentMonth = now.toLocaleString('es', { month: 'long' });
      return `${previousMonth} y ${currentMonth}`;
    } else {
      return now.toLocaleString('es', { month: 'long' });
    }
  };
  return (
    <div className="relative" ref={calendarRef}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        className="flex gap-2 cursor-pointer p-2 border rounded-md hover:bg-gray-50 w-fit"
      >
        <Badge variant="secondary" className="min-w-32">
          {startDate ? startDate.toLocaleDateString() : 'Fecha inicio'}
        </Badge>
        <Badge variant="secondary" className="min-w-32">
          {endDate ? endDate.toLocaleDateString() : 'Fecha fin'}
        </Badge>
      </div>

      {isOpen && (
        <Card className="absolute mt-2 z-50 shadow-lg">
          <CardContent className="p-2">
            <div className="mb-2 text-xs text-gray-600 text-center px-2">
              <span className="inline-flex items-center gap-1">
                📅 Disponible: <strong>{getMonthsText()}</strong>
              </span>
            </div>
            <Calendar
              mode="single"
              selected={startDate}
              onSelect={handleSelect}
              disabled={disableDate}
              modifiers={{
                selected: (date) => isDateInRange(date),
                today: (date) => date.toDateString() === new Date().toDateString(),
              }}
              modifiersClassNames={{
                selected: 'bg-blue-500 text-white hover:bg-blue-600',
                today: 'font-bold border border-blue-500',
              }}
              className="rounded-md border"
              fromDate={fromDate}
              toDate={toDate}
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default DateRangePicker;